import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/nocode/nocode_production/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/nocode/nocode_production/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/src/components/modules/appActions/appActionsList.js");
;
import(/* webpackMode: "eager" */ "/home/nocode/nocode_production/frontend/src/components/modules/appConnections/connectionsList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/src/components/modules/apps/appFollowButtonGroup.js");
;
import(/* webpackMode: "eager" */ "/home/nocode/nocode_production/frontend/src/components/modules/automations/automationsGrid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/src/components/modules/automations/automationsGridItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/src/components/modules/categories/categoryApps.js");
